// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
* {
  font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#root {
  width: 100%;
}
#root ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
#root p {
  line-height: 1.8rem;
}
#root p,
#root h1,
#root h2,
#root h3 {
  margin: 0;
}
#root button {
  cursor: pointer;
}
#root a {
  cursor: pointer;
  text-decoration: none;
}

*::marker {
  color: var(--orange-800) !important;
  width: 25px;
  height: 25px;
  place-content: center;
  place-items: center;
  font-size: 1.3rem;
}

:root {
  --white: #f4f4f4;
  --gray: #c6c6c6;
  --gold: #cd9a63;
  --black: #1e1e1e;
  --query-mobile: 320px;
  --query-tablet: 768px;
  --query-large: 992px;
  --query-notebook: 1024px;
  --font-chica: .75rem;
  --font-normal: .875rem;
  --font-boton: 1rem;
  --font-mediana: 1.1rem;
  --font-mediana2: 1.3rem;
  --font-grande: 1.5rem;
  --font-subtitulo: 2rem;
  --font-titulo: 2.5rem;
  --font-gigante: 3rem;
  --radius-5: 5px;
  --radius-10: 10px;
  --radius-15: 15px;
  --radius-20: 20px;
  --radius-25: 25px;
  --radius-30: 30px;
  --radius-35: 35px;
  --radius-40: 40px;
  --radius-45: 45px;
  --radius-50: 50px;
  --box-shadow-light: 0px 2px 10px 5px #e9e9e9 ;
}


.bg-white{
background-color: var(--white) !important;
}

.text-white{
color: var(--white) !important;
}


.bg-gray{
background-color: var(--gray) !important;
}

.text-gray{
color: var(--gray) !important;
}


.bg-gold{
background-color: var(--gold) !important;
}

.text-gold{
color: var(--gold) !important;
}


.bg-black{
background-color: var(--black) !important;
}

.text-black{
color: var(--black) !important;
}

.pointer{
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,8EAA8E;EAC9E,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;;;EAIE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,6CAA6C;AAC/C;;;AAGA;AACA,yCAAyC;AACzC;;AAEA;AACA,8BAA8B;AAC9B;;;AAGA;AACA,wCAAwC;AACxC;;AAEA;AACA,6BAA6B;AAC7B;;;AAGA;AACA,wCAAwC;AACxC;;AAEA;AACA,6BAA6B;AAC7B;;;AAGA;AACA,yCAAyC;AACzC;;AAEA;AACA,8BAA8B;AAC9B;;AAEA;EACE,eAAe;AACjB","sourcesContent":["@charset \"UTF-8\";\n* {\n  font-family: \"Source Sans Pro\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n#root {\n  width: 100%;\n}\n#root ul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n#root p {\n  line-height: 1.8rem;\n}\n#root p,\n#root h1,\n#root h2,\n#root h3 {\n  margin: 0;\n}\n#root button {\n  cursor: pointer;\n}\n#root a {\n  cursor: pointer;\n  text-decoration: none;\n}\n\n*::marker {\n  color: var(--orange-800) !important;\n  width: 25px;\n  height: 25px;\n  place-content: center;\n  place-items: center;\n  font-size: 1.3rem;\n}\n\n:root {\n  --white: #f4f4f4;\n  --gray: #c6c6c6;\n  --gold: #cd9a63;\n  --black: #1e1e1e;\n  --query-mobile: 320px;\n  --query-tablet: 768px;\n  --query-large: 992px;\n  --query-notebook: 1024px;\n  --font-chica: .75rem;\n  --font-normal: .875rem;\n  --font-boton: 1rem;\n  --font-mediana: 1.1rem;\n  --font-mediana2: 1.3rem;\n  --font-grande: 1.5rem;\n  --font-subtitulo: 2rem;\n  --font-titulo: 2.5rem;\n  --font-gigante: 3rem;\n  --radius-5: 5px;\n  --radius-10: 10px;\n  --radius-15: 15px;\n  --radius-20: 20px;\n  --radius-25: 25px;\n  --radius-30: 30px;\n  --radius-35: 35px;\n  --radius-40: 40px;\n  --radius-45: 45px;\n  --radius-50: 50px;\n  --box-shadow-light: 0px 2px 10px 5px #e9e9e9 ;\n}\n\n\n.bg-white{\nbackground-color: var(--white) !important;\n}\n\n.text-white{\ncolor: var(--white) !important;\n}\n\n\n.bg-gray{\nbackground-color: var(--gray) !important;\n}\n\n.text-gray{\ncolor: var(--gray) !important;\n}\n\n\n.bg-gold{\nbackground-color: var(--gold) !important;\n}\n\n.text-gold{\ncolor: var(--gold) !important;\n}\n\n\n.bg-black{\nbackground-color: var(--black) !important;\n}\n\n.text-black{\ncolor: var(--black) !important;\n}\n\n.pointer{\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
